<!--suppress HtmlUnknownTarget -->
<footer class="footer bg-dark text-light">
    <div class="w-100 contact-us row">
        <h3 class="main-header col-12">Contact Us</h3>
        <ul>
            <li>
               <header>By Mail</header>
            </li>
            <li>
                <span>8520 South Sandy Parkway</span>
            </li>
            <li>
                <span>Sandy, UT 84070</span>
            </li>
        </ul>

        <ul>
            <li>
                <header>By Email</header>
            </li>
            <li class="d-flex">
                <a href="mailTo:support@cmcflex.com">Software Support</a>
                <a href="mailTo:upgradeteam@cmcflex.com"><span>Upgrades</span></a>
            </li>
            <li class="d-flex">
                <a href="mailTo:hardware@cmcflex.com">Hardware Support</a>
                <a href="mailTo:training@cmcflex.com">Training/Webinars</a>
            </li>
            <li class="d-flex">
                <a href="mailTo:fwsupport@cmcflex.com">Firewall Support</a>
                <a href="mailTo:marketing@flexcutech.com">Marketing/Sales</a>
            </li>
            <li class="d-flex">
                <a href="mailTo:pcwebsupport@cmcflex.com">PC Web Support</a>
                <a href="mailTo:clientservices@cmcflex.com">Client Services</a>
            </li>
        </ul>

        <ul>
            <li>
                <header>By Phone</header>
            </li>
            <li>
                <span>800-262-3539</span>
            </li>
            <li>
                <span>801-365-5000</span>
            </li>
        </ul>

        <ul>
            <li>
                <header>By Fax</header>
            </li>
            <li>
                <span>Primary: 801-365-5100</span>
            </li>
            <li>
                <span>Sales: 801-545-4998</span>
            </li>
        </ul>
    </div>
    <section class="d-flex">
        <div class="col">
            <span style="font-size:.9em;">© {{currentYear}} Flexcutech. All Rights Reserved.</span>
        </div>
        <div class="col-3 social-media text-right">
            <a href="https://www.linkedin.com/company/flex-credit-union-technology"><i class="fab fa-linkedin fa-2x" aria-hidden="true"></i></a>
            <a href="https://twitter.com/flexcutech"><i class="fab fa-twitter-square fa-2x" aria-hidden="true"></i></a>
            <a href="https://www.facebook.com/flexcutech"><i class="fab fa-facebook-square fa-2x"></i></a>
        </div>
    </section>

</footer>
